// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Kkoe","content":"styles_content__1xbNx","row":"styles_row__1H3Cf","footer":"styles_footer__stTdP","phraseLength":"styles_phraseLength__32ThI"};